export const BALANCE_TRANSACTION_TYPES = { DEPOSIT: 'deposit', WITHDRAWAL: 'withdrawal' };

export const balanceTransactionsTypesTranslations = {
  [BALANCE_TRANSACTION_TYPES.DEPOSIT]: 'Поповнення',
  [BALANCE_TRANSACTION_TYPES.WITHDRAWAL]: 'Списання',
};
